import FuncionSindicalService from '../../services/FuncionSindicalService'

export default {
  namespaced: true,
  state: {
    funcionesSindicales: [],
    funcionSindical: null,
    totalItems: 0,
    currentPage: 1
  },
  getters: {
    funcionesSindicales: state => state.funcionesSindicales,
    funcionSindical: state => state.funcionSindical,
    totalItems: state => state.totalItems,
    currentPage: state => state.currentPage
  },
  mutations: {
    setFuncionesSindicales(state, funcionesSindicales) {
      state.funcionesSindicales = funcionesSindicales
    },
    setFuncionSindical(state, funcionSindical) {
      state.funcionSindical = funcionSindical
    },
    setTotalItems(state, totalItems) {
      state.totalItems = totalItems
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage
    }
  },
  actions: {
    async fetchFuncionesSindicales({ commit }, { page = 1, limit = 10, filters = {} }) {
      try {
        const response = await FuncionSindicalService.getFuncionesSindicales(page, limit, filters)
        commit('setFuncionesSindicales', response.data.data)
        commit('setTotalItems', response.data.total)
        commit('setCurrentPage', page)
        return response
      } catch (error) {
        console.error('Error fetching funciones sindicales:', error)
        throw error
      }
    },
    async fetchAllFuncionesSindicales({ commit }, filters = {}) {
      try {
        const response = await FuncionSindicalService.getAllFuncionesSindicales(filters)
        return response
      } catch (error) {
        console.error('Error fetching all funciones sindicales:', error)
        throw error
      }
    },
    async fetchFuncionSindical({ commit }, id) {
      try {
        const response = await FuncionSindicalService.getFuncionSindical(id)
        commit('setFuncionSindical', response.data.data)
        return response
      } catch (error) {
        console.error('Error fetching funcion sindical:', error)
        throw error
      }
    },
    async createFuncionSindical({ dispatch }, funcionSindical) {
      try {
        const response = await FuncionSindicalService.createFuncionSindical(funcionSindical)
        return response
      } catch (error) {
        console.error('Error creating funcion sindical:', error)
        throw error
      }
    },
    async updateFuncionSindical({ dispatch }, { id, funcionSindical }) {
      try {
        const response = await FuncionSindicalService.updateFuncionSindical(id, funcionSindical)
        return response
      } catch (error) {
        console.error('Error updating funcion sindical:', error)
        throw error
      }
    },
    async deleteFuncionSindical({ dispatch }, id) {
      try {
        const response = await FuncionSindicalService.deleteFuncionSindical(id)
        return response
      } catch (error) {
        console.error('Error deleting funcion sindical:', error)
        throw error
      }
    }
  }
}